/**
 * THE way to reach the assembler state: any component under the assembler
 * root subscribes with useFloorPlanAssemblerState() — never through props.
 * The context object (not a provider component) is exported so this package
 * stays component-free; web and React Native shells provide it from their roots.
 */
import { createContext, useContext } from 'react';
import type { FloorPlanAssemblerState } from './FloorPlanAssemblerState';

export const FloorPlanAssemblerStateContext = createContext<FloorPlanAssemblerState | null>(null);

export function useFloorPlanAssemblerState(): FloorPlanAssemblerState {
  const floorPlanAssemblerState = useContext(FloorPlanAssemblerStateContext);
  if (!floorPlanAssemblerState) {
    throw new Error('useFloorPlanAssemblerState must be used inside a FloorPlanAssemblerStateContext.Provider');
  }
  return floorPlanAssemblerState;
}
